import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  width = "100%",
  viewBox = "0 0 32 32"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M.5 23.75a.5.5 0 0 1-.5-.517 10.59 10.59 0 0 1 1.049-4.257c.733-1.475 3.241-2.396 6.712-3.672l.91-.335A.502.502 0 0 0 9 14.5v-.39a8.833 8.833 0 0 1-4.89-1.248.995.995 0 0 1-.49-.827.992.992 0 0 1 .269-.717c.498-.549.928-1.227 1.112-3.952.16-2.36 1.017-4.268 2.48-5.517C8.69.818 10.294.25 12 .25c1.705 0 3.31.568 4.519 1.599 1.463 1.249 2.321 3.156 2.48 5.516.184 2.726.615 3.405 1.117 3.958a.993.993 0 0 1 .231.931.993.993 0 0 1-.463.61 8.813 8.813 0 0 1-4.885 1.247v.39a.5.5 0 0 0 .326.467l.918.338c3.468 1.275 5.974 2.196 6.704 3.665a10.588 10.588 0 0 1 1.052 4.262.503.503 0 0 1-.5.518H.5zm22.469-1a9.58 9.58 0 0 0-.919-3.34c-.55-1.107-3.145-2.061-6.15-3.166l-.918-.338A1.508 1.508 0 0 1 14 14.501v-1.828c0-.422.179-.826.49-1.11a3.11 3.11 0 0 0 1.01-2.31V7.55a.486.486 0 0 0-.351-.473 6.994 6.994 0 0 1-3.136-1.829.067.067 0 0 1-.019-.006 7.055 7.055 0 0 1-3.149 1.841.479.479 0 0 0-.345.466v1.703a3.106 3.106 0 0 0 1.01 2.314c.311.283.49.687.49 1.109V14.5c0 .626-.395 1.191-.983 1.407l-.911.335c-3.008 1.105-5.606 2.06-6.159 3.173a9.56 9.56 0 0 0-.917 3.334h21.939zM15 13.105a7.797 7.797 0 0 0 4.375-1.102c-.746-.829-1.187-1.801-1.374-4.571C17.799 4.444 16.116 1.25 12 1.25c-4.116 0-5.799 3.194-6.001 6.184-.187 2.77-.628 3.74-1.375 4.562A7.74 7.74 0 0 0 9 13.104v-.43a.501.501 0 0 0-.164-.37A4.104 4.104 0 0 1 7.5 9.249V7.552a1.485 1.485 0 0 1 1.077-1.433 6.01 6.01 0 0 0 2.698-1.574l.199.155-.173-.181a.999.999 0 0 1 .693-.281h.03c.268.006.52.116.707.312a5.989 5.989 0 0 0 2.687 1.563 1.49 1.49 0 0 1 1.083 1.441V9.25a4.101 4.101 0 0 1-1.336 3.052.497.497 0 0 0-.165.371v.432z"
    />
  </svg>
);

export default SVG;
